import {css} from "@emotion/react";

import {calculateRemSize as crs, pointer} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {getOfferAddressText} from "../../offer/utils/get_offer_address_text";
import {clearOfferName} from "../utils/clear_offer_name";

interface IProps {
    offer: Pick<IOfferDetail, "name" | "street_name" | "street_number" | "region" | "vendor" | "id" | "slug" | "groups">;
    className?: string;
}

export function RankingOfferData(props: IProps) {
    const {offer, className} = props;
    const {name, vendor} = offer;

    const target = useResponsiveLinkTarget();
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id});

    const offerLink = useOfferLink(props.offer);

    return (
        <div css={offerData} className={className}>
            <a href={offerLink} css={offerInfo} target={target}>
                <Text as="h2" variant="headline_6">
                    {clearOfferName(name)}
                </Text>
                <Text as="p" variant="info_txt_1">
                    {getOfferAddressText(offer)}
                </Text>
            </a>
            {vendor.logo && (
                <a css={pointer} href={vendorLink} target={target}>
                    <Image alt={vendor.name} src={vendor.logo.v_log_80x60} width="72px" height="54px" />
                </a>
            )}
        </div>
    );
}

// Styles
const offerData = css`
    flex: 1;
    display: flex;
    align-items: center;
    gap: ${crs(1)};
`;

const offerInfo = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(0.5)};
    flex: 1;
`;
import {css} from "@emotion/react";

import {calculateRemSize as crs, pointer} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {getOfferAddressText} from "../../offer/utils/get_offer_address_text";
import {clearOfferName} from "../utils/clear_offer_name";

interface IProps {
    offer: Pick<IOfferDetail, "name" | "street_name" | "street_number" | "region" | "vendor" | "id" | "slug" | "groups">;
    className?: string;
}

export function RankingOfferData(props: IProps) {
    const {offer, className} = props;
    const {name, vendor} = offer;

    const target = useResponsiveLinkTarget();
    const vendorLink = rpAppLink.vendor.detail.base({vendorSlug: vendor.slug, vendorId: vendor.id});

    const offerLink = useOfferLink(props.offer);

    return (
        <div css={offerData} className={className}>
            <a href={offerLink} css={offerInfo} target={target}>
                <Text as="h2" variant="headline_6">
                    {clearOfferName(name)}
                </Text>
                <Text as="p" variant="info_txt_1">
                    {getOfferAddressText(offer)}
                </Text>
            </a>
            {vendor.logo && (
                <a css={pointer} href={vendorLink} target={target}>
                    <Image alt={vendor.name} src={vendor.logo.v_log_80x60} width="72px" height="54px" />
                </a>
            )}
        </div>
    );
}

// Styles
const offerData = css`
    flex: 1;
    display: flex;
    align-items: center;
    gap: ${crs(1)};
`;

const offerInfo = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(0.5)};
    flex: 1;
`;
